import {Component, forwardRef} from "@angular/core";
import {DeleteSearchActionComponent} from "../../../framework/common-controls/actions/delete-search-action.component";
import {SearchActionSelector} from "../../../framework/entity/search/search-grid/actions/search-action.component";
import {EntityModel, SearchModel} from "@fedeltapointofsale/data-client";
import {FUIAlertService} from "@fedeltapointofsale/ui";
import {AnalyticsService} from "../../../analytics/analytics.service";

/**
 * SearchAction to delete a company record from the grid.
 */
@Component({
    selector: "wbo-company-delete-search-action",
    template: "",
    providers: [
        {provide: SearchActionSelector, useExisting: forwardRef(() => CompanyDeleteSearchActionComponent), multi: true}
    ]
})
export class CompanyDeleteSearchActionComponent extends DeleteSearchActionComponent {
    constructor(searchModel: SearchModel<any>, entityModel: EntityModel<any>, alertService: FUIAlertService, analyticsService: AnalyticsService) {
        super(searchModel, entityModel, alertService, analyticsService);
    }

    override isAvailable(data: any): boolean {
        return super.isAvailable(data) && !data.defaultCompany;
    }
}
